import customersStore from 'relapp-customers/src/store/customers';

export default customersStore;
